const MAX_CACHE_SIZE = 5;

export function hashKey(str: string): string {
  let h1 = 0xdeadbeef;
  let h2 = 0x41c6ce57;
  for (let i = 0; i < str.length; i++) {
    const ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return ((h2 >>> 0) * 0x100000000 + (h1 >>> 0)).toString(36);
}

function getOrder(orderKey: string): string[] {
  try {
    return JSON.parse(sessionStorage.getItem(orderKey) || '[]');
  } catch {
    return [];
  }
}

function setOrder(orderKey: string, order: string[]): void {
  sessionStorage.setItem(orderKey, JSON.stringify(order));
}

export function useSessionCache<T>(prefix: string, orderKey: string) {
  const get = (key: string): T | null => {
    try {
      const data = sessionStorage.getItem(prefix + key);
      if (!data) return null;
      // Move to front (most recently used)
      const order = getOrder(orderKey).filter(k => k !== key);
      order.unshift(key);
      setOrder(orderKey, order);
      return JSON.parse(data) as T;
    } catch {
      return null;
    }
  };

  const set = (key: string, result: T): void => {
    try {
      const order = getOrder(orderKey).filter(k => k !== key);
      order.unshift(key);
      // Evict oldest if over capacity
      while (order.length > MAX_CACHE_SIZE) {
        const evicted = order.pop()!;
        sessionStorage.removeItem(prefix + evicted);
      }
      setOrder(orderKey, order);
      sessionStorage.setItem(prefix + key, JSON.stringify(result));
    } catch {
      // sessionStorage full or unavailable — silently skip caching
    }
  };

  return { get, set };
}
